import { useEffect, useState } from "react"

export function useCountdown(targetDate: Date) {
  const [timeLeft, setTimeLeft] = useState("00:00:00:00")
  const [isEnded, setIsEnded] = useState(false)

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date()
      const difference = targetDate.getTime() - now.getTime()

      if (difference <= 0) {
        setIsEnded(true)
        setTimeLeft("00:00:00:00")
        clearInterval(intervalId)
        return
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
      const minutes = Math.floor((difference / 1000 / 60) % 60)
      const seconds = Math.floor((difference / 1000) % 60)

      setTimeLeft(
        `${String(days).padStart(2, "0")}:${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
      )
    }

    const intervalId = setInterval(calculateTimeLeft, 1000)

    calculateTimeLeft()

    return () => clearInterval(intervalId)
  }, [targetDate])

  return { timeLeft, isEnded }
}
